import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    setTimeout(() => this.element.scrollIntoView({ block: "start", behavior: "instant" }), 750)
  }
}
